import { createContext, useContext } from 'react';

import { ALERT_SEVERITY } from '../enum/snackbarProps';

export interface SnackbarContextProps {
  open: boolean;
  severity: ALERT_SEVERITY;
  message: string;
  add: (severity: ALERT_SEVERITY, message: string) => void;
  remove: () => void;
}

export const SnackbarContext = createContext<SnackbarContextProps>(null!);

const useSnackbarContext = () => {
  return useContext<SnackbarContextProps>(SnackbarContext);
};

export default useSnackbarContext;
